package com.cs.ejobin.ui.screens.auth

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.cs.ejobin.i18n.Keys
import com.cs.ejobin.i18n.t
import com.cs.ejobin.ui.components.ScreenScaffold
import com.cs.ejobin.ui.theme.AppColors
import com.cs.ejobin.ui.theme.AppSurfaces
import ejobin.composeapp.generated.resources.Res
import ejobin.composeapp.generated.resources.eJobin_logo
import org.jetbrains.compose.resources.painterResource

@Composable
fun ForgotPasswordOtpScreen(
    onContinue: () -> Unit,
    onBack: () -> Unit
) {
    val primaryTextButtonColors = ButtonDefaults.textButtonColors(
        contentColor = AppColors.Primary
    )

    ScreenScaffold(
        title = "",
        scrollable = true,
        topActions = {}
    ) {
        Column(
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Spacer(Modifier.height(18.dp))

            Image(
                painter = painterResource(Res.drawable.eJobin_logo),
                contentDescription = "EJobin",
                modifier = Modifier.size(110.dp)
            )

            Spacer(Modifier.height(18.dp))

            Card(
                modifier = Modifier
                    .fillMaxWidth()
                    .widthIn(max = 520.dp),
                colors = AppSurfaces.glassCard(),
                border = CardDefaults.outlinedCardBorder()
            ) {
                Column(
                    modifier = Modifier.padding(18.dp),
                    verticalArrangement = Arrangement.spacedBy(12.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(
                        text = t(Keys.forgot_sent_title),
                        style = MaterialTheme.typography.titleLarge,
                        color = AppColors.TextPrimary
                    )

                    Text(
                        text = t(Keys.forgot_sent_body),
                        style = MaterialTheme.typography.bodyMedium,
                        color = AppColors.TextPrimary
                    )

                    Spacer(Modifier.height(6.dp))

                    Button(
                        onClick = onContinue,
                        modifier = Modifier.fillMaxWidth(),
                        colors = ButtonDefaults.buttonColors(containerColor = AppColors.Primary)
                    ) {
                        Text(t(Keys.forgot_continue))
                    }

                    TextButton(
                        onClick = onBack,
                        colors = primaryTextButtonColors
                    ) {
                        Text(t(Keys.forgot_back))
                    }
                }
            }

            Spacer(Modifier.height(18.dp))
        }
    }
}